import React from "react";

const ToasterContext = React.createContext({
    info: (title: string, text: string) => {},
    success: (title: string, text: string) => {},
    error: (title: string, text: string) => {},
});

export default ToasterContext;
